import { render } from "./NameGrid.vue?vue&type=template&id=0b82eb5c"
import script from "./NameGrid.vue?vue&type=script&lang=js"
export * from "./NameGrid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__